import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import { routes } from './config/route';
import { Provider } from 'react-redux';
import { createGlobalStyle } from 'styled-components';
import { styledDefault } from '@app/src/config/styles';
import { generateFontStyles } from '@app/src/config/fonts';
import { fetchSettings } from '@app/src/configuration/config.service';  
import configureStore from './store/configureStore';

const GlobalStyle = createGlobalStyle`
  ${styledDefault}
`;

const store = configureStore();

fetchSettings().then(() => {
  const fontStyles = generateFontStyles();
  const styleElement = document.createElement('style');
  styleElement.innerHTML = fontStyles;
  document.head.appendChild(styleElement);

  ReactDOM.render(
    <>
      <GlobalStyle />
      <Provider store={store}>
        <Router>
          {renderRoutes(routes)}
        </Router>
      </Provider>
    </>,
    document.getElementById('root')
  );
});
